import { ParsedWPBlock } from "@/src/types/Embeds";
import Image from "next/image";

const ImageBlock = ({ block }: { block: ParsedWPBlock }) => {
  try {
    // const regex = /<img[^>]+src="([^">]+)"/i;
    const regex = /<img[^>]+src="[^"]*wp-content\/([^">]+)"/i;
    const match = block.content?.match(regex);

    if (match?.length && match?.length > 1) {
      return (
        <div className="raw-image-container relative">
          <figure>
            <Image
              src={
                `https://blog.scplaybook.com.au/wp-content/${match[1]}` ?? ""
              }
              fill
              alt="image"
            />
          </figure>
        </div>
      );
    }
  } catch (e) {
    //todo add fallback for image maybe just dangerInnerHTML
    return <></>;
  }
};
export default ImageBlock;
